export default class FactureAvoirRecapController {
	static $inject = [
		'$scope',
		'$stateParams',
		'$state',
		'AvoirsService',
		'notification',
		'ModalService',
		'$uibModal',
		'moment',
		'$translate',
		'MassiaRightsService'
	];

	constructor($scope, $stateParams, $state, AvoirsService, notification, ModalService, $uibModal, moment, $translate, MassiaRightsService) {
		this.$scope = $scope;
		this.$stateParams = $stateParams;
		this.$state = $state;
		this.AvoirsService = AvoirsService;
		this.notification = notification;
		this.ModalService = ModalService;
		this.$uibModal = $uibModal;
		this.moment = moment;
		this.$translate = $translate;
		this.MassiaRightsService = MassiaRightsService;
	}

	async $onInit() {}

	annuler() {
		this.modalInstance.close();
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
